export default __webpack_public_path__ + "static/media/mobile_reward1_detail_4.6ca822f1.png";